import { render, staticRenderFns } from "./ProductOptionGuide.vue?vue&type=template&id=1620cd90&"
import script from "./ProductOptionGuide.vue?vue&type=script&lang=ts&"
export * from "./ProductOptionGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports